import React, { Component } from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

class TooltipByCLick extends Component {
	state = {
		open: false,
	};

	handleTooltipClose = () => {
		this.setState({ open: false });
	};

	handleTooltipOpen = () => {
		this.setState({ open: true });
	};

	render() {
		return (
			<ClickAwayListener onClickAway={this.handleTooltipClose}>
				<Tooltip
					{...this.props.tooltipProps}
					onClose={this.handleTooltipClose}
					open={this.state.open}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					onClick={this.handleTooltipOpen}
				>
					{this.props.children}
				</Tooltip>
			</ClickAwayListener>
		);
	}
}

export default TooltipByCLick;
